// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-dialog {
    min-width: 680px !important;
}

.modal-topview {
    border-bottom: 1px solid #98A2B3;
    padding: 30px;
    text-align: center;
}

.modal-topview img {
    width: 95px;
    height: 95px;
    object-fit: contain;
    margin-bottom: 20px;
}

.modal-topview p {
    font-size: 24px;
    line-height: 30.72px;
    font-family: 'Lora-Regular';
}

.modal-bodyview {
    padding-top: 25px;
    padding-bottom: 30px;
    padding-left: 54px;
    padding-right: 54px;
    text-align: center;
}


.back-btn {
    border: 1px solid #294859;
    padding: 15px 28px;
    border-radius: 100px;
    background-color: #294859;
    font-size: 16px;
    line-height: 18.8px;
    font-family: 'PublicSans-Regular';
    color: #FFFFFF;
    cursor: pointer;
    margin-top: 40px;
}

.selected-date2 {
    display: flex;
    align-items: flex-start;
    margin-top: 10px;
}

.selected-date2 p {
    color: #294859;
    font-size: 18px;
    line-height: 23.04px;
    font-family: 'Lora-Regular';
    text-align: left;
}

.calendar-outline {
    width: 24px !important;
    height: 24px !important;
    margin-right: 13px;
    object-fit: contain;
}

.appoiment-details {
    display: flex;
    flex-direction: row;
}

.appoiment-details img {
    width: 69px;
    height: 69px;
    object-fit: contain;
    border-radius: 100%;
}

.doctor-details {
    margin-left: 20px;
}

.doctor-details h2 {
    color: #294859;
    font-size: 24px;
    line-height: 28px;
    font-family: 'Lora-Medium';
    text-align: left;
    padding-bottom: 10px;
}

.doctor-details h3 {
    color: #294859;
    font-size: 20px;
    line-height: 25px;
    font-family: 'PublicSans-Regular';
    text-align: left;
    padding-bottom: 10px;
}

@media (max-width:600px) {
    .modal-dialog {
        min-width: 320px !important;
    }

    .back-btn {
        padding: 10px 18px;
        font-size: 14px;
    }
    .modal-topview p {
        font-size: 22px;
        line-height: 28.72px;
    }
    .appoiment-details img {
        width: 60px;
        height: 60px;
    }
    .modal-bodyview{
        padding-left: 30px;
        padding-right: 30px;
    }
    .modal-topview{
        padding: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/AppointmentBooked/style.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,iCAAiC;IACjC,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".modal-dialog {\n    min-width: 680px !important;\n}\n\n.modal-topview {\n    border-bottom: 1px solid #98A2B3;\n    padding: 30px;\n    text-align: center;\n}\n\n.modal-topview img {\n    width: 95px;\n    height: 95px;\n    object-fit: contain;\n    margin-bottom: 20px;\n}\n\n.modal-topview p {\n    font-size: 24px;\n    line-height: 30.72px;\n    font-family: 'Lora-Regular';\n}\n\n.modal-bodyview {\n    padding-top: 25px;\n    padding-bottom: 30px;\n    padding-left: 54px;\n    padding-right: 54px;\n    text-align: center;\n}\n\n\n.back-btn {\n    border: 1px solid #294859;\n    padding: 15px 28px;\n    border-radius: 100px;\n    background-color: #294859;\n    font-size: 16px;\n    line-height: 18.8px;\n    font-family: 'PublicSans-Regular';\n    color: #FFFFFF;\n    cursor: pointer;\n    margin-top: 40px;\n}\n\n.selected-date2 {\n    display: flex;\n    align-items: flex-start;\n    margin-top: 10px;\n}\n\n.selected-date2 p {\n    color: #294859;\n    font-size: 18px;\n    line-height: 23.04px;\n    font-family: 'Lora-Regular';\n    text-align: left;\n}\n\n.calendar-outline {\n    width: 24px !important;\n    height: 24px !important;\n    margin-right: 13px;\n    object-fit: contain;\n}\n\n.appoiment-details {\n    display: flex;\n    flex-direction: row;\n}\n\n.appoiment-details img {\n    width: 69px;\n    height: 69px;\n    object-fit: contain;\n    border-radius: 100%;\n}\n\n.doctor-details {\n    margin-left: 20px;\n}\n\n.doctor-details h2 {\n    color: #294859;\n    font-size: 24px;\n    line-height: 28px;\n    font-family: 'Lora-Medium';\n    text-align: left;\n    padding-bottom: 10px;\n}\n\n.doctor-details h3 {\n    color: #294859;\n    font-size: 20px;\n    line-height: 25px;\n    font-family: 'PublicSans-Regular';\n    text-align: left;\n    padding-bottom: 10px;\n}\n\n@media (max-width:600px) {\n    .modal-dialog {\n        min-width: 320px !important;\n    }\n\n    .back-btn {\n        padding: 10px 18px;\n        font-size: 14px;\n    }\n    .modal-topview p {\n        font-size: 22px;\n        line-height: 28.72px;\n    }\n    .appoiment-details img {\n        width: 60px;\n        height: 60px;\n    }\n    .modal-bodyview{\n        padding-left: 30px;\n        padding-right: 30px;\n    }\n    .modal-topview{\n        padding: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
